import { atom } from "recoil";
import { recoilPersist } from "recoil-persist";

export interface ILoginUser {
  tgUserId: number;
}

export interface IInsertUser {
  jettonWalletAddress: string;
  walletAddress: string;
  tgUserId: number;
}

export interface IJoinGroup {
  masterAddress: string;
  walletAddress: string;
  tgUserName: string;
}

export interface IUpdatePurge {
  masterAddress: string;
}

export interface IUserStoreUpdateState {
  userId?: string;
  walletAddresses?: WalletAddresses;
  tgUserId?: number;
}

export interface UserStoreState {
  userId?: string;
  walletAddresses?: WalletAddresses;
  tgUserId?: number;
  // tokens?: string;
  tgPhotoUrl?: string;
  tgUserName?: string;
  tonBalance?: number;
  preferences: Preferences;
  organizationId?: string;
  isExistingUser?: boolean;
  turnkeyUserId?: string;
  walletId?: string;
  email?: string;
  isCustodial?: boolean;
}

export interface Preferences {
  slippage?: number;
  validatorTip?: number;
  priorityFee?: number;
}

export interface WalletAddresses {
  tonAddress?: string;
  ethAddress?: string;
  solAddress?: string;
}

const { persistAtom } = recoilPersist({
  key: "userStateAtom",
});

// TODO
const userStateAtomV2 = atom<UserStoreState>({
  key: "userStateAtom",
  default: {
    userId: undefined,
    walletAddresses: {
      tonAddress: undefined,
      ethAddress: undefined,
      solAddress: undefined,
    },
    tgPhotoUrl: undefined,
    tgUserId: undefined,
    // tokens: undefined,
    tgUserName: undefined,
    tonBalance: undefined,
    preferences: {
      slippage: undefined,
      validatorTip: undefined,
      priorityFee: undefined,
    },
    walletId: undefined,
    turnkeyUserId: undefined,
    organizationId: undefined,
    isExistingUser: false,
    email: undefined,
    isCustodial: false,
  },
  effects_UNSTABLE: [persistAtom],
});

export { userStateAtomV2 };
